import React, { useState, useRef, useEffect } from 'react';

interface ExpandableProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
}

export const Expandable: React.FC<ExpandableProps> = ({
  title,
  children,
  defaultOpen = false,
  className = '',
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const [contentHeight, setContentHeight] = useState<number | undefined>(undefined);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [children]);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <button
    onClick={toggleOpen} className={`card relative transition-all duration-300 ease-in-out ${className} px-4 py-3 rounded-2xl`}>
      {/* Header - clickable */}
      <div
        onClick={toggleOpen}
        className="w-full flex items-center justify-between text-left focus:outline-none group"
        aria-expanded={isOpen}
      >
        <h3 className="text-base font-medium text-type-800 dark:text-neutral-100 group-hover:text-type-700 dark:group-hover:text-neutral-200 transition-colors">
          {title}
        </h3>
        
        {/* Plus/X icon */}
        <div className="relative w-8 h-8 flex items-center justify-center flex-shrink-0 ml-4">
          <span
            className={`absolute inset-0 flex items-center justify-center transition-transform duration-300 ease-in-out ${
              isOpen ? '-rotate-[135deg]' : 'rotate-0'
            }`}
          >
            {/* Vertical line of + */}
            <span className="absolute w-0.5 h-4 bg-type-600 dark:bg-neutral-400 rounded-full" />
            {/* Horizontal line of + */}
            <span className="absolute w-4 h-0.5 bg-type-600 dark:bg-neutral-400 rounded-full" />
          </span>
        </div>
      </div>

      {/* Content - expandable */}
      <div
        className="overflow-hidden transition-all duration-300 ease-in-out text-sm text-start dark:text-neutral-300"
        style={{
          maxHeight: isOpen ? `${contentHeight}px` : '0px',
          marginTop: isOpen ? '1rem' : '0',
          opacity: isOpen ? 1 : 0,
        }}
      >
        <div ref={contentRef}>
          {children}
        </div>
      </div>
    </button>
  );
};

